import {
  LOAD_ALL_RELATED_CONTACT,
  LOAD_SINGLE_RELATED_CONTACT,
} from "./RelatedContactList.saga";

export const loadAllRelatedContact = (payload) => ({
  type: LOAD_ALL_RELATED_CONTACT.LOADING,
  payload,
});

export const loadSingleRelatedContact = (payload) => ({
  type: LOAD_SINGLE_RELATED_CONTACT.LOADING,
  payload,
});
